import React, {Component} from 'react';
import * as moment from 'moment';

/**
 * Birth Date Input component
 */
class YearPicker extends Component {

  /**
   * Returns the array of year options for the drop down
   * @memberof YearPicker
   */
  getYears() {
    let current = parseInt(moment().format('YYYY'), 10);
    const end = parseInt(moment("1970").year(), 10);
    let output = [];

    while (current >= end){
      output.push(current);
      current--;
    }

    return output;
  }

  /**
   * Render the year picker
   */
  render() {
    const years = this.getYears();
    let {setYear, setMonth, selected} = this.props;

    let selectedYear;
    let selectedMonth;

    if (!selected || selected == null){
      selectedYear = moment().year();
      selectedMonth = moment().format('MMM');
    } else {
      selectedYear = moment(selected).year();
      selectedMonth = moment(selected).format('MMM');
    }

    if (!selectedYear){
      selectedYear = moment().year();
    }

    if (!selectedMonth || selectedMonth == null){
      selectedMonth = moment().format('MMM');
    }


    return (
      <div className="nppe2-fc-birth-date-input__picker-wrapper">

        <select className="keep-picker-open nppe2-fc-birth-date-input__picker"
          onChange={(e) => {
            setMonth(e.target.value)
          }}>
          {moment.monthsShort().map(item => (
            <option key={item} selected={selectedMonth == item ? true : false}>
              {item}
            </option>
          ))}
        </select>

        <select
          className="keep-picker-open nppe2-fc-birth-date-input__picker"
          onChange={(e) => {
            setYear(e.target.value)
          }}>

          {years.map((year, index) => (
            <option key={index} value= {years[index]} selected={selectedYear == years[index] ? true : false}>
              {years[index]}
            </option>
          ))}
          
        </select>

      </div>
    );
  }
};

export default YearPicker;
